// src/components/TawkToChat.jsx
import { useEffect } from "react";

const TawkToChat = () => {
  useEffect(() => {
    // Prevent loading twice
    if (window.Tawk_API) return;

    // ========== CUSTOMIZATION OPTIONS ==========
    // Set these BEFORE the script loads

    // 1. Custom widget position and offsets
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_API.customStyle = {
      visibility: {
        desktop: {
          position: "br", // br, bl, tr, tl, cr, cl
          xOffset: "250px", // horizontal offset from edge
          yOffset: "20px", // vertical offset from edge
        },
        mobile: {
          position: "br",
          xOffset: "10px",
          yOffset: "10px",
        },
      },
    };

    // 2. Pre‑fill visitor name & email (if you have logged‑in user data)
    // const user = JSON.parse(localStorage.getItem('user'));
    // if (user && user.name) {
    //   window.Tawk_API.visitor = {
    //     name: user.name,
    //     email: user.email
    //   };
    // }

    // 3. Optional: Hide widget on certain pages (e.g., admin area)
    // if (window.location.pathname.includes('/admin')) {
    //   window.Tawk_API = { hideWidget: true };
    // }

    // ========== ORIGINAL TAWK.TO SCRIPT ==========
    var Tawk_LoadStart = new Date();
    (function () {
      var s1 = document.createElement("script");
      var s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = "https://embed.tawk.to/69e39b4dccf03f1c363663db/1jmghd9ob"; // YOUR PROPERTY ID
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");
      s0.parentNode.insertBefore(s1, s0);
    })();
  }, []);

  return null;
};

export default TawkToChat;
